import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-kiki-line bg-[#FAF5EC] py-5 overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8">
            <span className={`font-display text-xl sm:text-2xl font-medium ${i % 2 === 0 ? "text-kiki-ink" : "text-outline-soft italic"}`}>
              {item}
            </span>
            <Sparkle className="w-3.5 h-3.5 text-kiki-gold/60 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
